import { render, staticRenderFns } from "./ProgrammeDocumentUploads.vue?vue&type=template&id=c896b846&scoped=true"
import script from "./ProgrammeDocumentUploads.vue?vue&type=script&lang=js"
export * from "./ProgrammeDocumentUploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c896b846",
  null
  
)

export default component.exports